import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDevotionCalendar } from "../store/devotionSlice";
import { monthKey } from "../utils/dateOnly";

export const useDevotionCalendar = (language = "en") => {
  const dispatch = useDispatch();
  const calendar = useSelector((state) => state.devotions.calendar || { byMonth: {}, loadingByMonth: {}, errorByMonth: {} });
  const loadMonth = useCallback((year, month, force = false) => {
    const key = monthKey(year, month, language);
    if (!force && calendar.byMonth[key]) return Promise.resolve(calendar.byMonth[key]);
    return dispatch(fetchDevotionCalendar({ year, month, language })).unwrap();
  }, [calendar.byMonth, dispatch, language]);
  const getMonth = useCallback((year, month) => calendar.byMonth[monthKey(year, month, language)], [calendar.byMonth, language]);
  const getState = useCallback((year, month) => {
    const key = monthKey(year, month, language);
    return { data: calendar.byMonth[key], loading: Boolean(calendar.loadingByMonth[key]), error: calendar.errorByMonth[key] };
  }, [calendar, language]);
  return useMemo(() => ({ loadMonth, getMonth, getState }), [getMonth, getState, loadMonth]);
};
